import {Button, css, Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	width: 100%;
	padding: 12px 16px;
	gap: 12px;
	box-shadow: 0px 4px 22px 0px #33333314;
	${({theme}) => css`
		background-color: ${theme.colors.gray['10Percent']};
		${theme.breakpoints.up('sm')} {
			padding: 12px 24px;
		}
	`}
`;

const StyledButton = styled(Button)`
	margin-top: auto;
	min-width: 0;
	font-weight: 400;
	text-decoration: underline;
	&:hover {
		text-decoration: underline;
	}
`;
export {StyledStack, StyledButton};
